<script lang="ts">
  import { icon } from '#app/lib/icons'
  import type { WorkEditionFilters } from '#entities/components/lib/editions_list_actions_helpers'
  import type { SerializedItemWithUserData } from '#inventory/lib/items'
  import ItemsMap from '#map/components/items_map.svelte'
  import type { EntityUri } from '#server/types/entity'
  import { i18n } from '#user/lib/i18n'
  import ItemsByCategories from './items_by_categories.svelte'

  let {
    editionsUris,
    mapWrapperEl = $bindable(),
    itemsListsWrapperEl = $bindable(),
    // showMap is false to be able to mount ItemsByCategories
    // to set initialBounds before mounting ItemsMap
    showMap = $bindable(false),
    waitingForItems,
    filteredItems,
    allItems,
    showMapAndScrollToMap,
    workEditionFilters = {},
  }: {
    editionsUris: EntityUri[]
    mapWrapperEl: HTMLElement
    itemsListsWrapperEl: HTMLElement
    showMap: boolean
    waitingForItems: Promise<SerializedItemWithUserData[]>
    filteredItems: SerializedItemWithUserData[]
    allItems: SerializedItemWithUserData[]
    showMapAndScrollToMap: () => void
    workEditionFilters?: WorkEditionFilters
  } = $props()

  let itemsOnMap: SerializedItemWithUserData[] = $state()

  function showItemsOnMap (items: SerializedItemWithUserData[]) {
    itemsOnMap = items
    showMapAndScrollToMap()
  }

  const displayCover = $derived(editionsUris?.length > 1)
</script>

<div class="items-lists-wrapper" bind:this={itemsListsWrapperEl}>
  <ItemsByCategories
    {filteredItems}
    {allItems}
    {displayCover}
    {waitingForItems}
    {showItemsOnMap}
    {workEditionFilters}
  />
</div>

{#if showMap}
  <div class="map-wrapper" bind:this={mapWrapperEl}>
    <ItemsMap
      {filteredItems}
      itemsToDisplay={itemsOnMap}
    />
    <button
      onclick={() => showMap = false}
      class="close-map-button"
      title={i18n('Close map')}
    >
      {@html icon('close')}
    </button>
  </div>
{/if}

<style lang="scss">
  @import "general/scss/utils";
  .map-wrapper, .items-lists-wrapper{
    align-self: stretch;
  }
  .map-wrapper{
    // Set to the .simple-map height to allow to scroll to the right level
    // before the map is rendered
    padding: 0.5em;
    min-block-size: 30em;
    position: relative;
    background-color: $off-white;
  }
  .close-map-button{
    @include position(absolute, 1rem, 1rem);
    // Above .leaflet-pane
    z-index: 401;
    padding: 0.2rem;
    margin: 0;
    font-size: 1.2rem;
    @include bg-hover(white);
    @include radius;
  }
  /* Small screens */
  @media screen and (width < $small-screen){
    .close-map-button{
      padding: 0.3em;
    }
  }
</style>
